export const getCreatedDateToString = (date: string) => {
    let createdDate = new Date(date);
    let dia = String(createdDate.getDate()).padStart(2, '0');
    let mes = String(createdDate.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
    let año = createdDate.getFullYear();
    let horas = String(createdDate.getHours()).padStart(2, '0');
    let minutos = String(createdDate.getMinutes()).padStart(2, '0');
    

    let fecha = `${dia}/${mes}/${año}`;
    let hora = `${horas}:${minutos}`
    return [fecha, hora]
}